import { streamAIResponse } from '../utils/ai-stream'

export default {
  data() {
    return {
      aiIsStreaming: false,
      aiIsThinking: false,
      aiThinkingLabel: '準備中',
      aiReasoningText: '',
      aiShowReasoning: false,
      _aiStreamController: null
    }
  },
  methods: {
    /**
     * Start AI streaming
     * @param {string} endpointUrl - Full URL of the AI endpoint
     * @param {FormData} formData - Form data
     * @param {Object} options - {
     *   resultField: 'aiResultMyprResult' or 'aiResultSummaryResult',
     *   viewField: 'aiResultView' or 'aiSummaryResultView',
     *   onDone: callback after completion,
     *   onError: callback on error
     * }
     */
    startAIStream(endpointUrl, formData, options = {}) {
      const resultField = options.resultField || 'aiResultMyprResult'
      const viewField = options.viewField || 'aiResultView'

      // Reset state
      this[resultField] = ''
      this[viewField] = true
      this.aiIsStreaming = true
      this.aiIsThinking = true
      this.aiThinkingLabel = '準備中'
      this.aiReasoningText = ''
      this.aiShowReasoning = false
      this.fullscreenLoading = false

      let fullText = ''

      this._aiStreamController = streamAIResponse(endpointUrl, formData, {
        onMeta: (meta) => {
          // Meta info received
        },
        onThinking: () => {
          this.aiIsThinking = true
          this.aiThinkingLabel = '思考中'
        },
        onReasoning: (content) => {
          this.aiThinkingLabel = '思考中'
          this.aiReasoningText += content
        },
        onText: (content) => {
          this.aiIsThinking = false
          fullText += content
          this[resultField] += content.replace(/\n/g, '<br>')
        },
        onDone: (data) => {
          this.aiIsStreaming = false
          this.aiIsThinking = false
          if (data.full_text) {
            fullText = data.full_text
            this[resultField] = fullText.replace(/\n/g, '<br>')
          }
          this.$message({ message: '取得しました', type: 'success' })
          if (options.onDone) options.onDone(data)
        },
        onError: (error) => {
          this.aiIsStreaming = false
          this.aiIsThinking = false
          const message = error.message || '失敗しました'
          if (message === 'AIの使用回数が上限に達しました。') {
            this.$message({
              message: '1日の上限に達しました。明日以降お試しください。',
              type: 'error'
            })
          } else {
            this.$message({ message, type: 'error' })
          }
          this[viewField] = false
          if (options.onError) options.onError(error)
        }
      })
    },
    toggleAiReasoning() {
      this.aiShowReasoning = !this.aiShowReasoning
    },
    cancelAIStream() {
      if (this._aiStreamController) {
        this._aiStreamController.abort()
        this._aiStreamController = null
        this.aiIsStreaming = false
        this.aiIsThinking = false
      }
    }
  },
  beforeDestroy() {
    this.cancelAIStream()
  }
}
